var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "info-main" },
    [
      _c(
        "el-form",
        {
          staticClass: "page-form",
          attrs: { model: _vm.Business, "label-position": "left" },
        },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("Business")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 40 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "BusinessName", label: "Business Name" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Business.BusinessName || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "BusinessRegistrationNumber",
                        label: "Business Registration Number",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.Business.BusinessRegistrationNumber || "--"
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        { staticClass: "page-form", attrs: { model: _vm.Location } },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("Location")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 40 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "BuildingNumber",
                        label: "Building Number",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Location.BuildingNumber || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "BuildingName", label: "Building Name" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Location.BuildingName || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "UnitNumber", label: "Unit Number" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Location.UnitNumber || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "StreetType", label: "Street Type" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Location.StreetType || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "StreetName", label: "Street Name" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Location.StreetName || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "City", label: "City" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Location.City || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          staticClass: "page-form",
          attrs: { model: _vm.Communication, "label-position": "left" },
        },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("Communication")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 40 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "Telephone", label: "Telephone Number" } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Communication.Telephone || "--") +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }